.wrap {
  max-width: var(--container);
  margin: 0 auto;
  padding: 20px var(--gutter) 0;
  box-sizing: border-box;
}

.crumbs {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 0;
  margin-bottom: 16px;
  font-size: 13px;
  color: var(--text-secondary);
}

.crumb {
  display: inline-flex;
  align-items: center;
  min-height: 44px;
}

.crumb + .crumb::before {
  content: '/';
  padding: 0 10px;
  color: var(--text-muted);
}

.top {
  display: grid;
  grid-template-areas: 'image' 'panel' 'body';
  gap: 24px;
}

.image {
  grid-area: image;
}

.image {
  display: block;
  width: 100%;
  aspect-ratio: 3 / 2;
  object-fit: cover;
  border-radius: var(--radius-card);
  background: var(--band);
}

.wide {
  aspect-ratio: 16 / 9;
}

.noImage {
  background: var(--border-strong);
}

.panel {
  grid-area: panel;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.category {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.24em;
  text-transform: uppercase;
  color: var(--label);
}

.title {
  margin: 0;
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 38px;
  line-height: 1.05;
}

.facts {
  margin: 8px 0 0;
  display: grid;
  border-top: 1px solid var(--border);
}

.fact {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 12px 0;
  border-bottom: 1px solid var(--border);
  font-size: 14px;
}

.fact dt {
  color: var(--text-secondary);
}

.fact dd {
  margin: 0;
  font-weight: 500;
  text-align: right;
}

.action {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
}

.body {
  grid-area: body;
  max-width: 760px;
  padding-top: 8px;
  font-size: 16px;
  line-height: 1.7;
  color: var(--text-body);
}

.body p {
  margin: 0 0 16px;
}

@media (min-width: 1024px) {
  .top {
    grid-template-columns: minmax(0, 1.4fr) minmax(0, 1fr);
    grid-template-areas: 'image panel' 'body body';
    gap: 0 48px;
    align-items: start;
  }

  .body {
    padding-top: 32px;
  }

  /* The panel spans the description's row too and rides along with it. */
  .sticky {
    grid-template-areas: 'image panel' 'body panel';
  }

  .sticky .panel {
    position: sticky;
    top: 24px;
  }

  .title {
    font-size: 48px;
  }
}
